'use client';

import { Badge } from '@up2stay/up2promo-ui';

import {
  SettingsGroupRow,
  SettingsGroupRows,
} from '@/core/components/settings/settings-group';
import { SettingsInfoHint } from '@/core/components/settings/settings-info-hint';
import { SettingsSection } from '@/core/components/settings/settings-section';

interface SecuritySectionProps {
  sectionId: string;
  dict: {
    title: string;
    description: string;
    twoFactor: string;
    twoFactorDescription: string;
    twoFactorComingSoon: string;
    sso: string;
    ssoDescription: string;
    ssoComingSoon: string;
    apiAccess: string;
    apiAccessDescription: string;
    apiAccessComingSoon: string;
  };
}

function ComingSoonRow({
  title,
  description,
  badge,
  separated,
}: {
  title: string;
  description: string;
  badge: string;
  separated?: boolean;
}) {
  return (
    <SettingsGroupRow separated={separated}>
      <div className="flex flex-wrap items-center justify-between gap-x-3 gap-y-1.5">
        <div className="flex min-w-0 flex-auto items-center gap-0.5">
          <span className="min-w-0 font-medium">{title}</span>
          <SettingsInfoHint label={title}>{description}</SettingsInfoHint>
        </div>
        <Badge variant="secondary" className="shrink-0">
          {badge}
        </Badge>
      </div>
    </SettingsGroupRow>
  );
}

export function SecuritySection({ sectionId, dict }: SecuritySectionProps) {
  return (
    <SettingsSection
      id={sectionId}
      title={dict.title}
      info={dict.description}
      grouped
    >
      <SettingsGroupRows>
        <ComingSoonRow
          title={dict.twoFactor}
          description={dict.twoFactorDescription}
          badge={dict.twoFactorComingSoon}
        />
        <ComingSoonRow
          separated
          title={dict.sso}
          description={dict.ssoDescription}
          badge={dict.ssoComingSoon}
        />
        <ComingSoonRow
          separated
          title={dict.apiAccess}
          description={dict.apiAccessDescription}
          badge={dict.apiAccessComingSoon}
        />
      </SettingsGroupRows>
    </SettingsSection>
  );
}
